import PropTypes from 'prop-types';
import { ChevronDownIcon, WorldIcon } from '@integration/alexandria-ui';
import { withTheme } from 'styled-components';

import {
  LanguageChevron,
  LanguageItem,
  LanguageText,
  LanguageTextContainer,
} from './LanguageStyled';
import { languageDictionary } from 'mappers/languages';

const LanguageMenuItem = ({
  handleOnClick,
  isOpen,
  itemLanguage,
  language,
  theme,
}) => {
  const selected = language === itemLanguage;
  return (
    <LanguageItem
      onClick={handleOnClick(itemLanguage, selected)}
      isRelevant={selected}
      data-testid={`menu-lang-${itemLanguage}`}
    >
      <LanguageTextContainer>
        {selected && <WorldIcon />}
        <LanguageText selected={selected}>
          {languageDictionary[itemLanguage]?.toUpperCase() || 'Random'}
        </LanguageText>
      </LanguageTextContainer>
      {selected && (
        <LanguageChevron isOpen={isOpen}>
          <ChevronDownIcon color={theme.primaryColor} />
        </LanguageChevron>
      )}
    </LanguageItem>
  );
};

LanguageMenuItem.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
  itemLanguage: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default withTheme(LanguageMenuItem);
